import { Modal } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import {
  fetchBookingByReservationShortCode,
  fetchBookings,
  fetchPendingBookings,
  fetchReservations,
  searchBookings,
  sendBookingReminder,
  setSelectedDate,
} from 'actions/booking';
import { showAlert } from 'actions/client';
import { fetchAllMenus, receiveAllMenus } from 'actions/venue';
import NotifySnackbar from 'components/Utility/Snackbars/NotifySnackbar';
import SearchBar from 'material-ui-search-bar';
import moment from 'moment';
import React from 'react';
import { isBrowser, isMobile } from 'react-device-detect';
import Loader from 'react-overlay-loader/lib/Loader';
import Pusher from 'react-pusher';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { DepositFilterTypes } from '../../../../../utils/constants/deposits';
import PillSelectBox from '../../MenuEditor/components/shared/PillSelectBox';
import BookingDetailsModal from './BookingDetailsModal';
import BookingsTable from './BookingsTable';
import './index.scss';
import PendingBookingsTable from './PendingBookingsTable';
import { getVenueSteps } from './TableCellGenerator';

const ListPadding = styled.div`
  padding: 30px 20px 20px;
  @media only screen and (max-width: 680px) {
    padding: 15px 10px;
  }
`;

const ListContainer = styled.div`
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #cccccc;
  max-width: 1120px;
  margin: auto;
  padding: 49px 24px 51px 49px;
  h1 {
    font-size: 18px;
  }
`;

const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  h1 {
    font-size: 32px;
    font-weight: 500;
  }
`;

const Container = styled.div`
  width: 100px;
  display: inline-block;
  margin-right: 10px;

  & > label {
    color: #797979;
    letter-spacing: -0.2px;
  }
`;

class ViewBookingsPanel extends React.Component {
  state = {
    timer: null,
    isSearching: false,
    searchValue: '',
    selectedBooking: null,
    showDetailsModal: false,
    subscribedToPusher: false,
    showBookingNotification: false,
    pendingBookingsOnly: false,
    newestBooking: null,
    currentDate: null,
    errorFetchingMenus: false,
    isPending: false,
    reservationDate: new Date().toLocaleDateString('en-CA'),
    searchResults: [],
    filterType: DepositFilterTypes.ALL_DEPOSITS,
  };

  constructor(props) {
    super(props);
    this.dateInputRef = React.createRef();
  }

  // Lifecycle

  componentDidUpdate(nextProps, nextState) {
    const defaultVenue = nextProps.defaultVenue;
    const oldDefaultVenue = this.props.defaultVenue;

    if (
      (!this.props.fetchingMenus &&
        !this.props.errorFetchingMenus &&
        (this.props.menuList === null || this.props.menuList === undefined)) ||
      oldDefaultVenue !== defaultVenue
    ) {
      this.props.fetchAllMenus();
    }
  }
  componentDidMount() {
    if (this.dateInputRef.current) {
      this.dateInputRef.current.addEventListener(
        'change',
        this.closeDatePicker
      );
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (!nextProps.sendingReminder && this.props.sendingReminder) {
      if (nextProps.reminderSent) {
        this.showReminderSent();
      } else {
        this.showReminderError();
      }
    }

    if (nextProps.draftBookings.length < this.props.draftBookings.length) {
      this.reloadAll();
    }
  }

  componentWillMount() {
    this.props.resetMenus();
    this.checkTime();

    this.props.fetchReservations(this.props.venue._id);

    this.props.fetchReservations(this.props.venue._id);

    const timer = setInterval(this.checkTime, 1000 * 5);
    this.setState({ timer, currentDate: this.getCurrentDate() });

    if (
      this.props.defaultVenue !== null &&
      this.props.defaultVenue !== undefined
    ) {
      this.props.fetchAllMenus();
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.timer);

    if (this.dateInputRef.current) {
      this.dateInputRef.current.removeEventListener(
        'change',
        this.closeDatePicker
      );
    }
  }
  closeDatePicker = () => {
    this.dateInputRef.current.blur();
  };

  onFilterChange = filterType => {
    this.setState({ filterType });
  };

  render() {
    const venueSteps = getVenueSteps(this.props.venue);
    const newestBooking = this.state.newestBooking || {};

    var { selectedDate } = this.props;
    selectedDate = this.getSelectedDate();

    const loadingPending = this.props.fetchingPendingBookings;
    const loadingSearch = this.props.fetchingSearchBookings;

    return (
      <div className="view-bookings">
        {isMobile && (
          <Button
            onClick={this.showBookingModal}
            variant="fab"
            color="primary"
            aria-label="add"
            className="add__booking__btn__mobile"
          >
            <Icon>add</Icon>
          </Button>
        )}
        <ListPadding>
          <ListContainer>
            <ListHeader>
              <h1>Reservations</h1>
              {isBrowser && (
                <Button
                  onClick={this.showBookingModal}
                  className="add__booking__btn__desktop"
                  color="primary"
                  variant="contained"
                >
                  <span className="add__booking__btn__text">
                    Create a Reservation
                  </span>
                </Button>
              )}
            </ListHeader>
            <div className="datetime__container">
              <div className="datetime__wrapper">
                <input
                  type="date"
                  className="datetime__input"
                  defaultValue={new Date().toLocaleDateString('en-CA')}
                  ref={this.dateInputRef}
                  onChange={e =>
                    this.setState({ reservationDate: e.target.value })
                  }
                />

                <Container>
                  <PillSelectBox
                    noMargin={true}
                    disabled={false}
                    value={this.state.filterType}
                    onChange={e => {
                      this.onFilterChange(e.target.value);
                    }}
                  >
                    <option
                      className="select-box__option"
                      value={DepositFilterTypes.ALL_DEPOSITS}
                    >
                      All Deposits
                    </option>
                    <option
                      className="select-box__option"
                      value={DepositFilterTypes.CONFIRMED_DEPOSITS}
                    >
                      Confirmed Deposits
                    </option>
                    <option
                      className="select-box__option"
                      value={DepositFilterTypes.PENDING_DEPOSITS}
                    >
                      Pending Deposits
                    </option>
                  </PillSelectBox>
                </Container>
              </div>
              <div className="search__wrapper">
                {' '}
                <SearchBar
                  className="bookings__search__bar"
                  placeholder="Search Name"
                  value={this.state.searchValue}
                  onChange={searchValue => this.onSearchRequest(searchValue)}
                  onRequestSearch={() =>
                    this.onSearchRequest(this.state.searchValue)
                  }
                  onCancelSearch={() => this.onSearchRequest('')}
                />
              </div>
            </div>
            <Paper
              className="bookings__paper"
              style={{
                borderRadius: 4,
                marginBottom: 24,
                //overflowX: 'scroll',
              }}
            >
              <div className="print__only">
                <h3 style={{ textAlign: 'center' }}>
                  Reservations for {selectedDate.format('YYYY-MM-DD')}
                </h3>
              </div>

              {this.state.pendingBookingsOnly && !this.state.isSearching && (
                <PendingBookingsTable
                  remindPendingBooking={this.remindPendingBooking}
                  venue={this.props.venue}
                  loading={loadingPending}
                  pendingBookingList={
                    [
                      ...this.props.draftBookings,
                      ...this.props.pendingBookingList,
                    ] || []
                  }
                  showBookingModal={this.showBookingModal}
                />
              )}

              <BookingsTable
                showBookingDetailsModal={this.showBookingDetailsModal}
                venue={this.props.venue}
                loading={loadingSearch}
                reservationDate={this.state.reservationDate}
                searchValue={this.state.searchValue}
                searchResults={this.state.searchResults}
                isPending={this.state.isPending}
                filterType={this.state.filterType}
                bookingList={this.props.reservationsList || []}
                showBookingModal={this.showBookingModal}
              />
            </Paper>
          </ListContainer>
        </ListPadding>
        <BookingDetailsModal
          askForTime={venueSteps.hasBookingTime}
          onComplete={this.completeDetailsModal}
          open={this.state.showDetailsModal}
          onClose={this.closeDetailsModal}
          booking={this.state.selectedBooking}
          fetchReservations={this.props.fetchReservations}
        />

        <NotifySnackbar
          message={`Booking confirmed for ${newestBooking.name}`}
          open={this.state.showBookingNotification}
          onClose={() => this.setState({ showBookingNotification: false })}
          actionIcon="visibility"
          onAction={() => this.showBookingModal(this.state.newestBooking)}
        />

        <Loader
          loading={this.props.sendingReminder || this.props.fetchingMenus}
        />

        <Pusher
          channel={`bookings-${this.props.venue._id}`}
          event="new-booking"
          onUpdate={this.receiveNewBookingData}
        />

        {this.props.bookingReservationsList && (
          <Modal
            open={this.state.showModal}
            onClose={this.handleCloseModal}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div className="order-container">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h5
                  style={{
                    margin: 0,
                    fontSize: '24px',
                    fontWeight: 700,
                    lineHeight: '32px',
                    letterSpacing: '-0.5px',
                  }}
                >
                  Order Details
                </h5>
                <button
                  onClick={this.handleCloseModal}
                  style={{
                    border: 'none',
                    background: 'none',
                    fontSize: '20px',
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              {this.props.bookingReservationsList.order_items.length === 0 ? (
                <p>No items selected.</p>
              ) : (
                <div>
                  {this.props.bookingReservationsList.order_items.map(
                    (item, index) => (
                      <div key={index}>
                        <p>
                          {item.name} x {item.quantity} - £ {item.price}
                        </p>
                        {index !==
                          this.props.bookingReservationsList.order_items
                            .length -
                            1 && <hr />}
                      </div>
                    )
                  )}
                </div>
              )}

              <hr />
              {this.props.bookingReservationsList.order_items.length > 0 && (
                <p style={{ textAlign: 'right' }}>
                  Total: £{' '}
                  {this.props.bookingReservationsList.order_items.reduce(
                    (total, item) => total + item.price * item.quantity,
                    0
                  )}
                </p>
              )}
            </div>
          </Modal>
        )}
      </div>
    );
  }

  // Timer Actions
  checkTime = () => {
    if (this.state.currentDate !== null) {
      const now = moment();
      const currentDate = this.state.currentDate;

      const sameDay = now.startOf('day').isSame(currentDate);

      if (!sameDay) {
        this.setDate(now);
        this.setState({ currentDate: now });
        this.reloadAll();
      }
    }
  };
  // Booking Actions
  onSearchRequest = query => {
    if (query !== '') {
      const searchResults = this.props.reservationsList.filter(reservation =>
        reservation.customer_name.toLowerCase().includes(query.toLowerCase())
      );

      if (searchResults.length === 0) {
        this.setState({
          searchResults: [],
          isSearching: true,
          searchValue: query,
        });
      } else {
        this.setState({ searchResults, isSearching: true, searchValue: query });
      }
    } else {
      this.setState({ searchResults: [], isSearching: false, searchValue: '' });
    }
  };

  // onSearchRequest = query => {
  //   console.log('searching for', query);

  //   // const isSearching = query !== '';
  //   // this.setState({ searchValue: query, isSearching: isSearching });
  //   // if (!isSearching) {
  //   //   return;
  //   // }

  //   // this.props.searchBookings(query);
  // };

  fetchInitialBookings = (force = false) => {
    const noBookings =
      !this.props.fetchingBookings && this.props.bookingList === null;
    const hasDefaultVenue = this.props.defaultVenue;
    const bookingFetchError = this.props.error;

    if (
      (noBookings && hasDefaultVenue && !bookingFetchError) ||
      (force && hasDefaultVenue)
    ) {
      var dateToFetch = this.getSelectedDate();

      if (force) {
        dateToFetch = this.getCurrentDate();
        this.setDate(dateToFetch);
      }

      // this.fetchBookings(dateToFetch);
    }
  };

  fetchPendingBookings = () => {
    // const startOfDay = moment(new Date()).utc(true).startOf('day');
    // this.props.fetchPendingBookings(startOfDay);
  };

  fetchBookings = date => {
    date = date.clone();
    const startOfDay = date.utc(true).startOf('day');
    const endOfDay = startOfDay.clone().endOf('day');

    this.props.fetchBookings(startOfDay, endOfDay);
  };

  switchPendingBookings = event => {
    const showPending = event.target.checked;

    if (showPending) {
      this.fetchPendingBookings();
    }

    this.setState({ pendingBookingsOnly: showPending });
  };

  showBookingDetailsModal = reservation_shortcode => {
    this.props.fetchBookingByReservationShortCode(reservation_shortcode);
    this.setState({
      showModal: true,
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  remindPendingBooking = booking => {
    this.props.sendBookingReminder(booking.id);
  };

  showReminderError = () => {
    this.props.showAlert(
      'Something went wrong',
      'Your reminder could not be sent. Please try again later.'
    );
  };

  showReminderSent = () => {
    this.props.showAlert(
      'Reminder Sent',
      'We have attempted to send an SMS and Email to the contact details provided.'
    );
  };

  // Date Actions

  onDateChanged = date => {
    this.setDate(date);
  };

  setDate = date => {
    this.props.setSelectedDate(moment(date.startOf('day')));
  };

  getCurrentDate = () => {
    return moment().startOf('day');
  };

  getSelectedDate = () => {
    return moment(this.props.selectedDate).startOf('day');
  };

  showPendingReservations = () => {
    this.setState({ isPending: !this.state.isPending });
  };

  // Pusher

  receiveNewBookingData = booking => {
    this.reloadAll();
    this.setState({ showBookingNotification: true, newestBooking: booking });
  };

  // Edit Bookings

  showBookingModal = booking => {
    if (!booking.id) {
      booking = undefined;
    }

    this.setState({ selectedBooking: booking, showDetailsModal: true });
  };

  closeDetailsModal = () =>
    this.setState({ showDetailsModal: false, selectedBooking: undefined });

  completeDetailsModal = (reloadAll = true) => {
    this.setState({ showDetailsModal: false, selectedBooking: undefined });

    // Re-fetch all the things
    if (reloadAll) {
      this.reloadAll();
    }
  };

  reloadAll = () => {
    // this.fetchBookings(this.getSelectedDate());
    // this.fetchPendingBookings();
    this.onSearchRequest(this.state.searchValue);
  };
}

const mapStateToProps = state => ({
  venue: state.venue,
  defaultVenue: state.venue.defaultVenue,
  bookingList: state.booking.bookingList,
  reservationsList: state.booking.reservationsList,
  pendingBookingList: state.booking.pendingBookingList,
  bookingReservationsList: state.booking.bookingReservationsList,
  draftBookings: state.booking.draftBookings,
  searchBookingList: state.booking.searchBookingList,
  fetchingBookings: state.booking.fetchingBookings,
  fetchingPendingBookings: state.booking.fetchingPendingBookings,
  fetchingSearchBookings: state.booking.fetchingSearchBookings,
  selectedDate: state.booking.selectedDate,
  sendingReminder: state.booking.sendingReminder,
  reminderSent: state.booking.reminderSent,
  fetchingMenus: state.venue.fetchingMenus,
  errorFetchingMenus: state.venue.errorFetchingMenus,
  menuList: state.venue.menus,
  error: state.error,
});

const mapDispatchToProps = dispatch => ({
  fetchReservations: venue_id => dispatch(fetchReservations(venue_id)),
  fetchBookingByReservationShortCode: reservation_shortcode =>
    dispatch(fetchBookingByReservationShortCode(reservation_shortcode)),

  fetchBookings: (from, to) => dispatch(fetchBookings(from, to)),

  searchBookings: query => dispatch(searchBookings(query)),
  fetchPendingBookings: from => dispatch(fetchPendingBookings(from)),
  sendBookingReminder: bookingID => dispatch(sendBookingReminder(bookingID)),
  setSelectedDate: date => dispatch(setSelectedDate(date)),
  fetchAllMenus: () => dispatch(fetchAllMenus()),
  resetMenus: () => dispatch(receiveAllMenus(null)),
  showAlert: (title, message) => dispatch(showAlert(title, message)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ViewBookingsPanel)
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/index.jsx